import { formatAnswerDay } from '@/shared/utils/deadline';

// errorIds is the Set of control ids the wizard marks invalid, the shape the
// shared blocks (blocks/blockUtils.js) and the faculty wizard use. An absent
// set means no errors.
export const hasError = (errorIds, id) => Boolean(errorIds && errorIds.has(id));

// The resume as the wizard holds it: the name, size and dates, never a key.
export const resumeFromApplication = (application) =>
    application?.resume
        ? {
              fileName: application.resume.fileName,
              size: application.resume.size,
              uploadedAt: application.resume.uploadedAt,
              copiedFromProfileAt: application.resume.copiedFromProfileAt,
              updatedAt: application.resume.updatedAt,
          }
        : null;

export const formatLongDate = formatAnswerDay;

export const formatFileSize = (bytes) => {
    if (!Number.isFinite(bytes)) return '';
    if (bytes < 1024) return `${bytes} bytes`;
    if (bytes < 1024 * 1024) return `${Math.round(bytes / 1024)} KB`;
    return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
};
